import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-campaign-popup',
  templateUrl: './campaign-popup.component.html',
  styleUrls: ['./campaign-popup.component.css']
})
export class CampaignPopupComponent implements OnInit {

  campaign: any;
  viewTnC: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data,
    public dialogRef: MatDialogRef<CampaignPopupComponent>
  ) { 
    this.campaign = this.data;
    // desc: "This is a test campaign description. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
    // id: "1"
    // image: "https://sushiizu.it-paradise.com.au/data/campaign/campaign.png"
    // image_web: "https://sushiizu.it-paradise.com.au/data/campaign/campaign.png"
    // name: "Test Campaign"
    // term: "https://sushiizu.it-paradise.com.au/data/content/170347203240Sushi-Izu-App-End-User-Licence-Agreement---Final.pdf"
  }

  ngOnInit(): void {
  }

}
